export default __webpack_public_path__ + "static/media/workflow-discovery.7a7d658e.jpg";